import React, { useState } from 'react';
import SocialButtons from './SocialButtons';

export default function SocialButtonsDropdown(props) {
    const [toggled, setToggled] = useState(false);

    function toggle(e) {
        e.preventDefault();
        e.stopPropagation();
        setToggled(!toggled);
    }

    return (
        <>
            <div className="relative h-[20px] w-[20px]">
                {toggled ?
                    <i className="bi-share text-cs4" onClick={toggle} />
                    :
                    <i className="bi-share" onClick={toggle} />
                }
                {toggled &&
                    <div className="absolute top-[-10px] left-[30px] h-[40px] w-[120px] flex items-center justify-center bg-cs1 shadow-md shadow-shadow rounded-md">
                        <div className="grid grid-cols-3 items-center gap-2">
                            <SocialButtons message={''} url={`${props.url}`} urlData={props.event} />
                        </div>
                    </div>
                }
            </div>
        </>
    );
}
